import React from 'react'

import styles from '../styles.module.css'

const Icon: React.FC = () => (
  <div className={styles['react-cookienotice-icon']} />
)

export default Icon
